<template>
	<transition name="el-fade-in-linear">
    <div v-show="transitionshow">  

		<!-- 基本信息设置 -->
		<el-form :inline="true" class="bbackborder4 demo-form-inline" size="small">
			<el-col :span="6">
				<el-form-item label="提成名称" label-width="30">
					<el-input placeholder="请输入提成制度名称" v-model="create.name" ></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="9">
				<el-form-item label="有效时间" label-width="30">
					<el-date-picker v-model="create.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :unlink-panels="false" @change="ischange=true"></el-date-picker>
				</el-form-item>
			</el-col>
			<el-col :span="8">
				<el-form-item>
					<el-button type="danger" icon="el-icon-plus" @click="addmonths">新增月销售目标</el-button>
				</el-form-item>
			</el-col>
        </el-form>

		<!-- 适用销售渠道 -->
		<div class="bbackborder4" style="padding:1% 1% 1% 1%;margin-top:10px;font-size:.9rem;">
			<el-col :span="24" style="float:left;width:100%;border-bottom:1px solid rgb(221,221,221,.5);padding-bottom:.5rem">
				<span style="float:left">适用销售渠道</span>
				<el-button type="success" size="mini" circle icon="el-icon-arrow-down" style="float:right" @click="showandcloseline"></el-button>
			</el-col>
			<el-col :span="24" class="showmonths" :style="showlineheight">
				<el-checkbox-group v-model="create.saletypes">
					<el-checkbox v-for="(item,index) in roallists" :label="item.id" :key="index">{{item.name}}</el-checkbox>
				</el-checkbox-group>
			</el-col>
		</div>

		<!-- 适用销售员 -->
		<div class="bbackborder4" style="padding:1% 1% 1% 1%;margin-top:10px;font-size:.9rem;">
			<el-col :span="24" style="float:left;width:100%;border-bottom:1px solid rgb(221,221,221,.5);padding-bottom:.5rem">
				<span style="float:left">适用销售员</span>
				<el-button type="success" size="mini" circle icon="el-icon-arrow-down" style="float:right" @click="showandcloseclerk"></el-button>
			</el-col>
			<el-col :span="24" class="showmonths" :style="showclerkheight">
				<el-checkbox-group v-model="create.clerkids">
					<el-checkbox v-for="(item,index) in clerklists" :label="item.id" :key="index">{{item.name}}</el-checkbox>
				</el-checkbox-group>
			</el-col>
		</div>

		<!-- 月销售额信息列表 -->
		<div class="bbackborder4" style="padding:1% 1% 1% 1%;margin-top:10px;font-size:.9rem;">
			<el-col :span="24" style="float:left;width:100%;border-bottom:1px solid rgb(221,221,221,.5);padding-bottom:.5rem">
				<span style="float:left">月销售目标</span>
				<el-button type="success" size="mini" circle icon="el-icon-arrow-down" style="float:right" @click="showandclosemonth"></el-button>
			</el-col>
			<el-col :span="24" class="showmonths" :style="showmonheight">
				<ul class="monul">
					<li v-for="(item,index) in salelists" :key="index">
						<div class="moninside" :class="item.isshow=='false' ? noisshow : isshow " @click="selectmonths(index)">
							<div class="setting">
								<span style="float:left;">{{item.time}}</span>
								<el-button type="danger" size="mini" circle icon="el-icon-delete" style="float:right" @click="delmonths(index)"></el-button>
								<el-button type="primary" size="mini" circle icon="el-icon-setting" style="float:right;margin-right:2%" @click="copyallmonth(index)"></el-button>
							</div>
							<div class="setting" style="margin-top:.5rem;border-bottom:0" @click="setprice(index)">
								<div v-if="item.iswrite=='false'" style="color:#E6A23C;font-weight:bold;height:40px;line-height:40px">￥{{item.price}}</div>
								<el-input v-if="item.iswrite=='true'" placeholder="请输入销售目标金额" v-model="item.price" @focus="inputfocus(index)" @blur="ensureprice(index)" :ref="item.ref"></el-input>
							</div>
						</div>
					</li>
				</ul>
			</el-col>
		</div>

		<!-- 选择月份信息列表 -->
		<el-dialog title="选择月销售明细" :visible.sync="addmonthDialog"  width="25%" top="10vh">
			<el-table :data="monthlists" v-loading="addmonthloading">
                <el-table-column label="月份" prop="time"></el-table-column>
				<el-table-column label="操作" width="110" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type="info" icon="el-icon-check" circle @click="selectmonth(scope.$index)" v-if="scope.row.isselect==false"></el-button>
                        <el-button size="mini" type="success" icon="el-icon-check" circle @click="selectmonth(scope.$index)" v-if="scope.row.isselect==true"></el-button>
                    </template>
				</el-table-column>
          	</el-table>
			<div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="addmonthDialog = false">取 消</el-button>
				<el-button size="primary" @click="ensuremonth">确 定</el-button>
            </div>
		</el-dialog>

		<!-- 提成设置 -->
		<div class="bbackborder4" style="padding:1% 1% 1% 1%;margin-top:10px;font-size:.9rem;" v-if="showsetting==true">
			<el-col :span="24" style="float:left;width:100%;border-bottom:1px solid rgb(221,221,221,.5);padding-bottom:.5rem">
				<span style="float:left">提成信息设置（{{settingname}}）</span>
				<el-button type="success" size="mini" circle icon="el-icon-arrow-down" style="float:right" @click="showandclosesetting"></el-button>
			</el-col>
			<el-col :span="24" class="showmonths" :style="showsettingheight">
				
				<!-- 普通提成设置 -->
				<div style="float:left;width:98%;padding:.5rem 1% .5rem 1%;background:rgb(221,221,221,.5);border-radius:5px">
					<div style="float:left;width:100%;font-width:bold;border-bottom:1px solid #fff;padding-bottom:.5rem">
						<span style="float:left;">普通提成设置<i style="color:red;font-style:normal">（温馨提示：适用于除特殊品牌、特殊商品以外所有商品销售，优先级最低）</i></span>
						<el-button type="danger" size="mini" icon="el-icon-plus" circle style="float:right" @click="addnormalsetting"></el-button>
					</div>
					<el-table :data="saleliststemp.normal">
						<el-table-column label="最低销售额（元）" align="center">
							<template slot-scope="scope">
								<el-input primary="text" v-model="scope.row.low"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="最高销售额（元）" align="center">
							<template slot-scope="scope">
								<el-input primary="text" v-model="scope.row.height"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="提成比例（%）" align="center">
							<template slot-scope="scope">
								<el-input primary="text" v-model="scope.row.percent"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="110" align="center">
							<template slot-scope="scope">
								<el-button size="mini" type="danger" icon="el-icon-delete" circle @click="delnormalpercent(scope.$index)"></el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				
				<!-- 特殊品牌提成设置 -->
				<div style="float:left;width:98%;margin-top:10px;padding:.5rem 1% .5rem 1%;background:rgb(221,221,221,.5);border-radius:5px">
					<div style="float:left;width:100%;font-width:bold;border-bottom:1px solid #fff;padding-bottom:.5rem">
						<span style="float:left;">特殊品牌提成设置<i style="color:red;font-style:normal">（温馨提示：适用于指定品牌商品的销售计算，优先级低于特殊商品）</i></span>
						<el-button type="danger" size="mini" icon="el-icon-plus" circle style="float:right" @click="addbrandpercent"></el-button>
					</div>

					<div v-for="(t,i) in saleliststemp.brand" :key="i" style="float:left;width:100%;margin-top:10px">
						<div style="float:left;width:98%;border-radius:5px;background:#fff;padding:.5rem 1% .5rem 1%;">
							<div style="float:left;width:70%;min-height:1rem">
								<el-tag v-for="(tt,ii) in t.brandnames" :key="ii" closable type="success" style="float:left;margin:0 1% .5rem 0" @close="closebrands(i,ii)">{{tt}}</el-tag>
							</div>
							<div style="float:left;width:30%;">
								<el-button type="danger" size="mini" icon="el-icon-delete" circle style="float:right;" @click="delbrands(i)"></el-button>
								<el-button type="danger" size="mini" icon="el-icon-plus" circle style="float:right;margin:0 2% 0 0" @click="addbrandinfopercent(i)"></el-button>
								<el-button type="primary" size="mini" icon="el-icon-search" circle style="float:right;margin:0 2% 0 0" @click="searchbrands(i)"></el-button>
							</div>
						</div>
						<el-table :data="t.percent">
							<el-table-column label="最低销售额（元）" align="center">
								<template slot-scope="scope">
									<el-input primary="text" v-model="scope.row.low"></el-input>
								</template>
							</el-table-column>
							<el-table-column label="最高销售额（元）" align="center">
								<template slot-scope="scope">
									<el-input primary="text" v-model="scope.row.height"></el-input>
								</template>
							</el-table-column>
							<el-table-column label="提成比例（%）" align="center">
								<template slot-scope="scope">
									<el-input primary="text" v-model="scope.row.percent"></el-input>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="110" align="center">
								<template slot-scope="scope">
									<el-button size="mini" type="danger" icon="el-icon-delete" circle @click="delbranddetailspercent(i,scope.$index)"></el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>

				<!-- 特殊提成商品设置 -->
				<div style="float:left;width:98%;margin-top:10px;padding:.5rem 1% .5rem 1%;background:rgb(221,221,221,.5);border-radius:5px">
					<div style="float:left;width:100%;font-width:bold;border-bottom:1px solid #fff;padding-bottom:.5rem">
						<span style="float:left;">特殊商品提成设置<i style="color:red;font-style:normal">（温馨提示：适用于指定商品的销售计算，优先级最高）</i></span>
						<el-button type="danger" size="mini" icon="el-icon-plus" circle style="float:right" @click="addgoodspercent"></el-button>
					</div>
					<div v-for="(t,i) in saleliststemp.goods" :key="i" style="float:left;width:100%;margin-top:10px">
						<div style="float:left;width:98%;border-radius:5px;background:#fff;padding:.5rem 1% .5rem 1%;">
							<div style="float:left;width:70%;min-height:1rem">
								<el-tag v-for="(tt,ii) in t.goodsnames" :key="ii" closable type="success" style="float:left;margin:0 1% .5rem 0" @close="closegoods(i,ii)">{{tt}}</el-tag>
							</div>
							<div style="float:left;width:30%;">
								<el-button type="danger" size="mini" icon="el-icon-delete" circle style="float:right;" @click="delgoods(i)"></el-button>
								<el-button type="danger" size="mini" icon="el-icon-plus" circle style="float:right;margin:0 2% 0 0" @click="addgoodsinfopercent(i)"></el-button>
								<el-button type="primary" size="mini" icon="el-icon-search" circle style="float:right;margin:0 2% 0 0" @click="searchgoods(i)"></el-button>
							</div>
						</div>
						<el-table :data="t.percent">
							<el-table-column label="最低销售额（元）" align="center">
								<template slot-scope="scope">
									<el-input primary="text" v-model="scope.row.low"></el-input>
								</template>
							</el-table-column>
							<el-table-column label="最高销售额（元）" align="center">
								<template slot-scope="scope">
									<el-input primary="text" v-model="scope.row.height"></el-input>
								</template>
							</el-table-column>
							<el-table-column label="提成比例（%）" align="center">
								<template slot-scope="scope">
									<el-input primary="text" v-model="scope.row.percent"></el-input>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="110" align="center">
								<template slot-scope="scope">
									<el-button size="mini" type="danger" icon="el-icon-delete" circle @click="delgoodsdetailspercent(i,scope.$index)"></el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<el-button type="primary" size="small" style="float:right;margin:10px 0 10px 0" :loading="savepercentloading" @click="savepercent">确 定</el-button>
			</el-col>
		</div>


		<!-- 获取品牌信息列表 -->
		<el-dialog title="品牌信息表" :visible.sync="brandDialog"  width="60%" top="10vh">
			<el-form :inline="true" class="demo-form-inline" size="mini">
				<el-form-item>
					<el-input placeholder="请输入关键字" clearable @keyup.enter.native="getbrands" v-model="brandquery.key" @change="brandchange=true"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getbrands">查询</el-button>
				</el-form-item>
			</el-form>
			<el-table :data="brandlists" v-loading="brandlistLoading">
                <el-table-column label="品牌" prop="name"></el-table-column>
				<el-table-column label="操作" width="110" align="center">
					<template slot-scope="scope">
						<el-button size="mini" :type="scope.row.isselect==true ? 'success' : 'info'" icon="el-icon-check" circle @click="changeselectbrand(scope.row,scope.$index)"></el-button>
                    </template>
				</el-table-column>
          	</el-table>
			<div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="brandDialog = false">取 消</el-button>
				<el-button size="primary" @click="ensurebrands">确 定</el-button>
            </div>
			<div class="block">
			<!--分页begin-->
			<el-pagination
				@size-change="brandpageSizeChange"
				@current-change="brandpageCurrentChange"
				:current-page="brandquery.p"
				:page-sizes="[10, 20, 50]"
				:page-size="brandquery.rollpage"
				layout="total, sizes, prev, pager, next, jumper"
				:total="brand_rows">
			</el-pagination>
			<!--分页end-->
			</div>
		</el-dialog>

		<!-- 获取商品信息列表 -->
		<el-dialog title="品牌信息表" :visible.sync="goodsDialog"  width="60%" top="5vh">

			<el-form :inline="true" class="demo-form-inline" size="mini">
				<el-form-item style="width:15%">
					<el-select v-model="goodsquery.type" filterable placeholder="按品牌" @change="goodschange=true">	          
						<el-option v-for="(item,index) in goodstypes" :label="item.name" :value="item.id" :key="index"></el-option>
					</el-select>
    			</el-form-item>
				<el-form-item style="width:20%">
					<el-select v-model="goodsquery.brandid" filterable clearable placeholder="按品牌" @change="goodschange=true">	          
						<el-option label="不分品牌" value="0"></el-option>
						<el-option v-for="(item,index) in goodsbrandlists" :label="item.showlable" :value="item.id" :key="index">
							<span style="float: left">{{item.name}}</span>
							<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
						</el-option>
					</el-select>
    			</el-form-item>
				<el-form-item>
					<el-input placeholder="请输入关键字" clearable @keyup.enter.native="getgoods" v-model="goodsquery.key" @change="goodschange=true"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getgoods">查询</el-button>
				</el-form-item>
			</el-form>

			<el-table :data="goodslists" v-loading="goodslistLoading">
                <el-table-column label="商品" prop="name"></el-table-column>
				<el-table-column label="品牌" prop="brandname"></el-table-column>
				<el-table-column label="操作" width="110" align="center">
					<template slot-scope="scope">
						<el-button size="mini" :type="scope.row.isselect==true ? 'success' : 'info'" icon="el-icon-check" circle @click="changeselectgoods(scope.row,scope.$index)"></el-button>
                    </template>
				</el-table-column>
          	</el-table>
			<div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="goodsDialog = false">取 消</el-button>
				<el-button size="primary" @click="ensuregoods">确 定</el-button>
            </div>
			<div class="block">
			<!--分页begin-->
			<el-pagination
				@size-change="goodspageSizeChange"
				@current-change="goodspageCurrentChange"
				:current-page="goodsquery.p"
				:page-sizes="[10, 20, 50]"
				:page-size="goodsquery.rollpage"
				layout="total, sizes, prev, pager, next, jumper"
				:total="goods_rows">
			</el-pagination>
			<!--分页end-->
			</div>
		</el-dialog>
                      
	</div>
	</transition>
</template>

<script>
export default {
  props:['childdata'],
  data () {
    return {
      actionauth:'', //操作功能权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Percent/index",
	  showmonheight:{'max-height':'100rem'},
	  showlineheight:{'max-height':'5rem'},
	  showclerkheight: {'max-height':'10rem'},
	  showsettingheight: {'max-height':'100rem'},
      create: {
		  act:'savepercentnews',
		  token:this.$cookies.get('token'),
		  id:'',
		  name:'',
		  saletypes:[],
		  clerkids:[],
		  date:[],
		  salelists:[],
	  },
	  salelists:[],
	  roallists:[],
      clerklists:[],
	  monthlists:[],
	  addmonthDialog:false,
	  addmonthloading:false,
	  isshow:'moninside monon',
	  noisshow:'moninside',
	  settingindex:-1,
	  settingname:'',
	  saleliststemp:[],
	  showsetting:false,
	  searchbrandindex:-1,

	  brandquery:{
        act:'lists',
		egnoreids:[],
        token:this.$cookies.get('token'),
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      brand_rows: 0,
	  brandlistLoading:false,
	  brandlists:[],
	  brandDialog:false,
	  brandchange:false,
	  brandtempids:[],
	  brandtempnames:[],
	  searchgoodsindex:-1,
	  goodsDialog:false,
	  goodschange:false,
	  goodslistLoading:false,
	  goodslists:[],
	  goodstempids:[],
	  goodstempnames:[],
	  goodstemptypes:[],
	  goods_rows:0,
	  goodsquery: {
	  	  act:'getsettinggoodslists',
		  token:this.$cookies.get('token'),
		  egnoreids:[],
		  egnoretypes:[],
		  brandid:'',
		  type:1,
		  key:'',
		  p:1,
		  rollpage:10
	  },
	  goodsbrandlists:[],
	  goodstypes:[{id:1,name:'宠赞'},{id:2,name:'京东'}],
	  savepercentloading:false,

    }
  },

  mounted(){
      this.getactionauth();
	  this.getclerk(); //获取销售员信息
	  this.getsalestypelists(); ///获取销售渠道信息
	  this.getgoodsBrand(); //获取品牌信息列表
	  this.getpercentdetails(); //获取提成信息详情
  },
  methods:{

	  /** 获取销售渠道信息 **/
	  getsalestypelists() {
		  var resource = this.$resource(this.url);
          resource.query({act:'getsaletypes',token:this.$cookies.get('token')}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	          }else{
	              this.roallists = JSON.parse(Base64.decode(res.data.Data));
	          }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
          });
	  },

	  /** 获取提成信息详情 **/
	  getpercentdetails() {
		  var resource = this.$resource(this.url);
      	  resource.query({act:'getpercentinfodetails',token:this.$cookies.get('token'),id:this.childdata.id}).then((res) => {
      		  if(res.data.Result>0){
          		  if(res.data.Result=='70001') this.$router.push('/login');
          		  this.$message.error(res.data.Message);
        	  }else{
				  var _this=this;
          		  var result = JSON.parse(Base64.decode(res.data.Data));
				  this.create.id=result.id;
				  this.create.name=result.name;
				  this.create.date=result.date;
				  this.create.saletypes=result.saletypes;
				  this.create.clerkids=result.clerkids;
				  this.create.salelists=result.salelists;
				  this.salelists=result.salelists;
        	  }
      	  }).catch((res) => {
            
      	  });
	  },

	  /** 获取品牌 **/
      getgoodsBrand(){
          var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
          resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	          }else{
	              this.goodsbrandlists = JSON.parse(Base64.decode(res.data.Data));
	          }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
          });
      },

	  /** 获取职员信息 **/
      getclerk() {
			var url=this.GLOBAL.domain+"Percent/index";
			var resource = this.$resource(url);
			resource.query({act:'getclerk',token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.clerklists = JSON.parse(Base64.decode(res.data.Data));
				}
			}).catch((res) => {
				this.$message.error(this.GLOBAL.errortext);
			});
      },

	  /** 获取操作功能权限 **/
	  getactionauth() {
		  var data =this.$cookies.get('actionauth');
		  data=JSON.parse(data);
		  this.actionauth=data;
	  },

	  /** 编辑月销售金额 **/
	  setprice(index) {
		  this.inputfocus(index);
	  },

	  /** 光标聚焦 **/
	  inputfocus(index) {
		  var _this=this;
		  this.salelists.forEach(function(item,i) {
			  _this.salelists[i].iswrite='false';
		  });
		  this.salelists[index].iswrite='true';
	  },

	  /** 完成月销售金额编辑 **/
	  ensureprice(index) {
		  this.salelists[index].iswrite='false';
	  },

	  /** 新增月销售金额信息 **/
	  addmonths() {
		  var times=[];
		  this.salelists.forEach(function(item,i) {times.push(item.time)});

		  this.addmonthDialog=true;
		  this.addmonthloading=true;
		  var resource = this.$resource(this.url);
		  resource.save({act:'addmonths',token:this.$cookies.get('token'),date:this.create.date,mytime:times}).then((res) => {
			  if(res.data.Result>0){
				  if(res.data.Result=='70001') this.$router.push('/login')
				  this.$message.error(res.data.Message);
				  this.addmonthloading=false;
			  }else{
				  this.monthlists = JSON.parse(Base64.decode(res.data.Data));
				  this.addmonthloading=false;
			  }
		  }).catch((res) => {
			  this.$message.error(this.GLOBAL.errortext);
			  this.addmonthloading=false;
		  });
	  },
	  /** 删除月销售金额信息 **/
	  delmonths(index) {
		  var normalresult=this.salelists[index].setting.normal.length;
		  var brandresult=this.salelists[index].setting.brand.length;
		  var goodsresult=this.salelists[index].setting.goods.length;

		  if((normalresult > 0 || brandresult > 0 || goodsresult > 0)) { //原月份信息有数据，提示是否要删除
			  
			  this.$confirm('该月份提成信息已编辑有数据，是否删除 ？, 是否继续?', '提示', { type: 'warning' }).then(() => {
				  this.salelists.splice(index,1);
				  if(index==this.settingindex) { //如删除的月份正式当前编辑的月份时清空临时信息
					  this.settingindex=-1;
					  this.settingname='';
				  	  this.showsetting=false;
					  this.saleliststemp=[];
				  }
			  }).catch(() => {
				  
			  });

		  }else { //原月份信息无数据直接删除
			  this.salelists.splice(index,1);
			  if(index==this.settingindex) { //如删除的月份正式当前编辑的月份时清空临时信息
				  this.settingindex=-1;
				  this.settingname='';
				  this.showsetting=false;
				  this.saleliststemp=[];

		  	  }
		  }

	  },


	  //展开、关闭销售渠道
	  showandcloseline() {
		  this.showlineheight['max-height']=='5rem' ? this.showlineheight['max-height']="0" : this.showlineheight['max-height']="5rem";
	  },

	  //展开、关闭销售员
	  showandcloseclerk() {
		  this.showclerkheight['max-height']=='10rem' ? this.showclerkheight['max-height']="0" : this.showclerkheight['max-height']="10rem";
	  },

	  //展开、关闭月销售额信息
	  showandclosemonth() {
		  this.showmonheight['max-height']=='100rem' ? this.showmonheight['max-height']="0" : this.showmonheight['max-height']="100rem";
	  },

	  //展开、关闭提成设置
	  showandclosesetting() {
		  this.showsettingheight['max-height']=='100rem' ? this.showsettingheight['max-height']="0" : this.showsettingheight['max-height']="100rem";
	  },

	  //选择月销售目标
	  selectmonth(index) {
		  this.monthlists[index].isselect==false ? this.monthlists[index].isselect=true : this.monthlists[index].isselect=false;
	  },

	  //确认选择月销售目标
	  ensuremonth() {		  
		  var _this=this;
		  var time=[];
		  this.showmonheight['max-height']='100rem';
		  this.salelists.forEach(function(item,i) {time.push(item.time)});
		  this.monthlists.forEach(function(item,i) {
			  time.indexOf(item.time) == -1 && item.isselect==true ? _this.salelists.push({time:item.time,price:'',iswrite:'false',isshow:'false',number:item.number,setting:{normal:[],brand:[],goods:[]}}) : '';
		  });

		  //移交后台重新排序
		  var resource = this.$resource(this.url);
		  resource.save({act:'changemonthsort',token:this.$cookies.get('token'),data:this.salelists}).then((res) => {
			  if(res.data.Result>0){
				  if(res.data.Result=='70001') this.$router.push('/login')
				  this.$message.error(res.data.Message);
			  }else{
				  this.salelists = JSON.parse(Base64.decode(res.data.Data));
				  this.addmonthDialog=false;
			  }
		  }).catch((res) => {
			  this.$message.error(this.GLOBAL.errortext);
		  });
	  },

	  //选择月销售目标
	  selectmonths(index) {
		  var _this=this;
		  if(index!=this.settingindex && this.settingindex!=-1) {
			  var stindex=this.settingindex;
			  this.salelists[stindex].setting=this.saleliststemp;
		  }


		  //标记选中的月份信息
		  this.salelists.forEach(function(item,i) {_this.salelists[i].isshow='false'});
		  this.salelists[index].isshow='true';
		  //提取数组id信息
		  this.settingindex=index;
		  this.settingname=this.salelists[index].time;
		  //展示编辑页面
		  this.showsetting=true;
		  this.showmonheight['max-height']='100rem';
		  //将提成设置信息写入临时月提成销售信息设置
		  this.saleliststemp=this.salelists[index].setting;
	  },


	  //新增普通提成设置信息
	  addnormalsetting() {
		  var index=this.settingindex;
		  this.saleliststemp.normal.push({low:'',height:'',percent:''});
	  },
	  //删除普通提成信息设置
	  delnormalpercent(index) {
		  this.saleliststemp.normal.splice(index,1);
	  },
	  

	  /********************************** 特殊品牌信息功能区域 ************************************/
	  //新增特殊品牌提成信息设置
	  addbrandpercent() {
		  this.saleliststemp.brand.push({brandids:[],brandnames:[],percent:[]});
	  },
	  //删除整个特殊品牌提成信息设置
	  delbrands(index) {
		  var brandids=this.saleliststemp.brand[index].brandids.length;
		  var brandnames=this.saleliststemp.brand[index].brandnames.length;
		  var percent=this.saleliststemp.brand[index].percent.length;

		  if(brandids > 0 || brandnames > 0 || percent > 0) { //原月份信息有数据，提示是否要删除
			  this.$confirm('您是否要删除该品牌提成设置，是否删除 ？, 是否继续?', '提示', { type: 'warning' }).then(() => {
				  this.saleliststemp.brand.splice(index,1);
			  }).catch(() => {
				  
			  });

		  }else {
			  this.saleliststemp.brand.splice(index,1);
		  }

	  },
	  //新增特殊品牌具体提成信息
	  addbrandinfopercent(index) {
		  this.saleliststemp.brand[index].percent.push({low:'',height:'',percent:''});
	  },
	  //删除特殊品牌具体提成信息
	  delbranddetailspercent(bindex,sindex) {
		  this.saleliststemp.brand[bindex].percent.splice(sindex,1);
	  },

	  //获取添加的品牌信息
	  searchbrands(index) {
		  var _this=this;
		  var bids=[];
		  this.searchbrandindex=index;
		  //提取现有品牌id
		  this.saleliststemp.brand.forEach(function(t,i) {
			  t.brandids.forEach(function(tt,ii) {
				  bids.push(tt);
			  });
		  });

		  this.brandtempids=[];
	  	  this.brandtempnames=[];

		  this.brandquery.egnoreids=bids;
		  this.brandquery.key='';
		  this.brandquery.p=1;
		  this.brandquery.rollpage=10;
		  this.getbrands();
	  },

	  //信息列表
	  getbrands(){
		  if(this.brandchange==true) {this.brandquery.p=1;this.brandquery.rollpage=10;}
		  this.brandDialog=true;
		  this.brandlistLoading = true;
		  var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
		  resource.save(this.brandquery).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.brandlistLoading = false;
		    }else{
				this.brandlists = JSON.parse(Base64.decode(res.data.Data));
				var result=[];
				var isselect=false;
				var _this=this;
				this.brandlists.forEach(function(item,i) {
					isselect=_this.brandtempids.indexOf(item.id) >=0 ? true : false;
					result.push({id:item.id,name:item.name,isselect:isselect});
				});
				this.brandlists=result;

				this.brand_rows=parseInt(res.data.count);
				this.brandlistLoading = false;
				if(this.brandchange==true) this.brandchange=false;
			}
		  }).catch((res) => {
			  this.$message.error(this.GLOBAL.errortext);
			  this.brandlistLoading=false;
		  });
	  },
	  brandpageSizeChange(val) {
			this.brandquery.rollpage = val;
			this.getbrands();
	  },
	  brandpageCurrentChange(val) {
			this.brandquery.p = val;
			this.getbrands();
	  },

	  //选择、取消选择品牌信息
	  changeselectbrand(item,index) {
		  if(this.brandtempids.indexOf(item.id) >=0 ) { //删除品牌信息
		  	  var number=this.brandtempids.indexOf(item.id);
			  this.brandtempids.splice(number,1);
			  this.brandtempnames.splice(number,1);
			  this.brandlists[index].isselect=false;
		  }else { //新增品牌信息
			  this.brandtempids.push(item.id);
			  this.brandtempnames.push(item.name);
			  this.brandlists[index].isselect=true;
		  }
	  },

	  //确认已选中的品牌信息
	  ensurebrands() {		  
		  var ids=[];
		  var _this=this;
		  var number=this.searchbrandindex;
		  this.saleliststemp.brand[number].brandids.forEach(function(item,i) {ids.push(item)});

		  this.brandtempids.forEach(function(t,i) {
			  if(ids.indexOf(t) ==-1) {
				  _this.saleliststemp.brand[number].brandids.push(t);
				  _this.saleliststemp.brand[number].brandnames.push(_this.brandtempnames[i]);
			  }
		  });
		  this.brandDialog=false;
	  },

	  //删除品牌信息
	  closebrands(bindex,sindex) {
		  this.saleliststemp.brand[bindex].brandids.splice(sindex,1);
		  this.saleliststemp.brand[bindex].brandnames.splice(sindex,1);
	  },
	  /********************************** 特殊品牌信息功能区域 ************************************/


	  /************************************* 特殊商品信息功能区域 ******************************************/
	  //新增特殊商品提成信息设置
	  addgoodspercent() {
		  this.saleliststemp.goods.push({goodsids:[],goodsnames:[],goodstype:[],percent:[]});
	  },
	  //删除特殊商品信息
	  delgoods(index) {
		  var goodsids=this.saleliststemp.goods[index].goodsids.length;
		  var goodsnames=this.saleliststemp.goods[index].goodsnames.length;
		  var goodstype=this.saleliststemp.goods[index].goodstype.length;
		  var percent=this.saleliststemp.goods[index].percent.length;

		  if(goodsids > 0 || goodsnames > 0 || goodstype > 0 || percent > 0) { //原月份信息有数据，提示是否要删除
			  this.$confirm('您是否要删除该商品提成设置，是否删除 ？, 是否继续?', '提示', { type: 'warning' }).then(() => {
				  this.saleliststemp.goods.splice(index,1);
			  }).catch(() => {
				  
			  });

		  }else {
			  this.saleliststemp.goods.splice(index,1);
		  }

	  },
	  //添加特殊商品提成设置详情
	  addgoodsinfopercent(index) {
		  this.saleliststemp.goods[index].percent.push({low:'',height:'',percent:''});
	  },
	  //删除特殊商品提成设置详情
	  delgoodsdetailspercent(bindex,sindex) {
		  this.saleliststemp.goods[bindex].percent.splice(sindex,1);
	  },
	  //获取搜索的商品信息
	  searchgoods(index) {
		  var _this=this;
		  var gids=[];
		  var gnames=[];
		  var gtypes=[];
		  this.searchgoodsindex=index;
		  //提取现有品牌id
		  this.saleliststemp.goods.forEach(function(t,i) {
			  t.goodsids.forEach(function(tt,ii) {gids.push(tt)});
			  t.goodsnames.forEach(function(tt,ii) {gnames.push(tt)});
			  t.goodstype.forEach(function(tt,ii) {gtypes.push(tt)});
		  });

		  this.goodstempids=[];
	  	  this.goodstempnames=[];
		  this.goodstemptypes=[];

		  this.goodsquery.egnoreids=gids;
		  this.goodsquery.egnoretypes=gtypes;
		  this.goodsquery.key='';
		  this.goodsquery.brandid='';
		  this.goodsquery.type=1;
		  this.goodsquery.p=1;
		  this.goodsquery.rollpage=10;
		  this.getgoods();
	  },

	  //搜索特殊商品信息
	  getgoods(index) {
		  if(this.goodschange==true) {this.goodsquery.p=1;this.goodsquery.rollpage=10;}
		  this.goodsDialog=true;
		  this.goodslistLoading = true;
		  var resource = this.$resource(this.url);
		  resource.save(this.goodsquery).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.goodslistLoading = false;
		    }else{
				var _this=this;
				this.goodslists = JSON.parse(Base64.decode(res.data.Data));
				this.goodslists.forEach(function(item,i) {
					var numbers=-1;
					numbers=_this.goodstempids.indexOf(item.id);
					if(numbers >=0 && item.id==_this.goodstempids[numbers] && item.type==_this.goodstemptypes[numbers]) _this.goodslists[numbers].isselect=true;
				});

				this.goods_rows=parseInt(res.data.count);
				this.goodslistLoading = false;
				if(this.goodschange==true) this.goodschange=false;
			}
		  }).catch((res) => {
			  this.$message.error(this.GLOBAL.errortext);
			  this.goodslistLoading=false;
		  });
	  },
	  goodspageSizeChange(val) {
		  this.goodsquery.rollpage = val;
		  this.getgoods();
	  },
	  goodspageCurrentChange(val) {
		  this.goodsquery.p = val;
		  this.getgoods();
	  },
	  //选择、取消选择商品信息
	  changeselectgoods(item,index) {
		  var isselect=false;
		  var nbs=-1;
		  var type=-1;
		  
		  nbs=this.goodstempids.indexOf(item.id);
		  if(nbs >=0 && item.id==this.goodstempids[nbs] && item.type==this.goodstemptypes[nbs]) isselect=true;
		  if(isselect==false) { //没有添加
			  this.goodslists[index].isselect=true;
			  this.goodstempids.push(item.id);
	  	  	  item.type==1 ? this.goodstempnames.push(item.name+'（宠赞）') : this.goodstempnames.push(item.name+'（京东）');
		  	  this.goodstemptypes.push(item.type);

		  }else { //已添加、取消添加
			  this.goodslists[index].isselect=false;
			  this.goodstempids.splice(nbs,1);
	  	  	  this.goodstempnames.splice(nbs,1);
		  	  this.goodstemptypes.splice(nbs,1);
		  }
	  },
	  //确认添加特殊商品信息
	  ensuregoods() {		  
		  var _this=this;
		  var index=this.searchgoodsindex;
		  var data=this.saleliststemp.goods[index];
		  this.goodstempids.forEach(function(item,i) {
			  var number=data.goodsids.indexOf(item);
			  if(number==-1) {
				  _this.saleliststemp.goods[index].goodsids.push(item);
				  _this.saleliststemp.goods[index].goodsnames.push(_this.goodstempnames[i]);
				  _this.saleliststemp.goods[index].goodstype.push(_this.goodstemptypes[i]);
			  }else if(number >=0 && _this.goodstemptypes[i]!=data.goodstype[number]) {
				  _this.saleliststemp.goods[index].goodsids.push(item);
				  _this.saleliststemp.goods[index].goodsnames.push(_this.goodstempnames[i]);
				  _this.saleliststemp.goods[index].goodstype.push(_this.goodstemptypes[i]);
			  }

		  });
		  this.goodsDialog=false;
	  },


	  //删除整个特殊已添加的特殊商品信息
	  closegoods(bindex,sindex) {
		  this.saleliststemp.goods[bindex].goodsids.splice(sindex,1);
		  this.saleliststemp.goods[bindex].goodsnames.splice(sindex,1);
		  this.saleliststemp.goods[bindex].goodstype.splice(sindex,1);
	  },

	  /************************************* 特殊商品信息功能区域 ******************************************/
	  

	  //提交保存提成信息
	  savepercent() {
		  //保存正在编辑的月销售额信息
		  if(this.settingindex!=-1) {
			  var stindex=this.settingindex;
			  this.salelists[stindex].setting=this.saleliststemp;
		  }
		  this.create.salelists=this.salelists;
	      
	      this.savepercentloading=false;
		  var resource = this.$resource(this.url);
		  resource.save(this.create).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.savepercentloading = false;
		    }else{
				this.$message.success('保存提成信息成功！');
				this.savepercentloading=false;
				this.salelists=[];
				this.settingindex=-1;
				this.settingname='';
				this.saleliststemp=[];
				this.showsetting=false;
				this.searchbrandindex=-1;
				this.searchgoodsindex=-1;
				this.$emit('closechild','Percentedit'); //关闭窗口

				//重置提成信息
				this.create.name='';
		 		this.create.saletypes=[];
		  	    this.create.clerkids=[];
		  		this.create.date=[];
		  		this.create.salelists=[];
			}
		  }).catch((res) => {
			  this.$message.error(this.GLOBAL.errortext);
			  this.savepercentloading=false;
		  });
	  },


	  //将该月份的提成设置信息复制粘贴到其它所有月份
	  copyallmonth(index) {
		  this.$confirm('将该月的提成信息复制粘贴到所有月份会导致其它月份提成详情信息被覆盖, 是否继续?', '提示', { type: 'warning' }).then(() => {
			  var _this=this;
			  var localsales=this.salelists[index];
			  this.salelists.forEach(function(item,i) {
				  if(index!=i) {
					  _this.salelists[i].price=localsales.price;
					  _this.salelists[i].iswrite=localsales.iswrite;
					  _this.salelists[i].isshow=localsales.isshow;
					  _this.salelists[i].setting=localsales.setting;
				  }
			  });
		  }).catch(() => {
				  
		  });
	  },

  }
}
</script>
<style>
.bbackborder4 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%;float:left;width:98%}
.backborder3 {background:#fff;border-radius:15px;border:1px solid #ddd;float:left;width:98%;padding:1% 1% 0 1%;}
.showmonths {margin-top:.5rem;transition:all .5s;overflow:hidden}
.el-checkbox__input.is-checked+.el-checkbox__label {color:#606266}
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {background-color:#E6A23C;color:#E6A23C;border-color:#E6A23C}
.monul {padding:0;margin-top:.5rem}
.monul li {float:left;width:20%;height:6rem;list-style-type:none;margin:10px 2% 10px 0;cursor:pointer;}
.moninside {float:left;width:90%;height:5rem;padding:.5rem 5% .5rem 5%;border:1px solid rgb(211,211,211,.7);background:rgb(211,211,211,.3);border-radius:5px;transition:all .3s}
.monon {background:#fff}
.moninside .setting {float:left;width:100%;border-bottom:1px solid rgb(221,221,221,.5);padding-bottom:.3rem;}
.moninside:hover {margin-top:-.5rem;box-shadow: 8px 8px 5px rgb(211,211,211);}
</style>


// WEBPACK FOOTER //
// src/components/base/Percentedit.vue